export default [
  { label: 'U.S. Citizen or U.S. National', value: 'us_citizen' },
  { label: 'U.S. Dual Citizen', value: 'us_dual_citizen' },
  { label: 'U.S. Permanent Resident', value: 'us_pr' },
  { label: 'U.S. Refugee or Asylee', value: 'us_refugee' },
  { label: 'Other (Non-U.S.)', value: 'other' },
]